var _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWeight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  clipPath: "url(#clip0_324_3468)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m7.772 10.184-2.333 7a1 1 0 0 0 .948 1.316h11.226a1 1 0 0 0 .948-1.316l-2.333-7a1 1 0 0 0-.949-.684H8.721a1 1 0 0 0-.949.684Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 7.5,
  r: 2
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 23,
  height: 23,
  x: 0.5,
  y: 1,
  stroke: "currentColor",
  rx: 3.5
})));
export default SvgWeight;